import {NgModule} from '@angular/core';
import {AdministrationToDisplayNamePipe} from './administration-to-display-name.pipe';

@NgModule({
  declarations: [AdministrationToDisplayNamePipe],
  exports: [AdministrationToDisplayNamePipe],
})
export class AdministrationToDisplayNameModule {}
